import { isAllOf, isAnyOf, isFulfilled, isRejectedWithValue } from "@reduxjs/toolkit";
const isMutation = (action) => action.meta.arg.type === "mutation";
const isAuthorized = (action) => action.meta.baseQueryMeta.request.headers.get('authorization');
const isSettledAsyncThunk = isAnyOf(isRejectedWithValue, isFulfilled);
export const isSettledMutation = isAllOf(isSettledAsyncThunk, isMutation);
export const isAuthorizedSettledMutation = isAllOf(isSettledAsyncThunk, isMutation, isAuthorized);
